import Slider from "react-slick";
import { useTranslation } from 'react-i18next';
import { images } from '../../constants';
import { skills } from '../../data';
import './skills.scss';

const Skills = () => {
    const { t } = useTranslation();

    const settings = {
        arrows: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 2000,
        rows: 3,
        pauseOnHover: true,
        responsive: [
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            }
        },
        {
            breakpoint: 475,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 1
            }
        },
        {
            breakpoint: 350,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }
        ]
    };

  return (
      <div className='Skills container'>
          <h1>{t('skills.title')}</h1>

          <div className="skills_collection ">
          <Slider {...settings}>
                {skills.map((skill, index) => (
                  <div key={index}>
                    <img src={images[skill.imageKey]} alt={skill.alt} />
                  </div>
                ))}
                </Slider>
          </div>
      </div>
  )
}

export default Skills